var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextButtonOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.998779,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#A0AEC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0965 23.1248L17.3582 28.1698C16.985 28.3853 16.5616 28.4988 16.1307 28.4988C15.6998 28.4988 15.2764 28.3854 14.9032 28.1699C14.53 27.9544 14.2201 27.6445 14.0047 27.2713C13.7892 26.8981 13.6758 26.4747 13.6758 26.0438V15.9537C13.6758 15.5228 13.7892 15.0994 14.0047 14.7262C14.2202 14.353 14.5301 14.0431 14.9033 13.8277C15.2764 13.6122 15.6998 13.4988 16.1307 13.4988C16.5616 13.4988 16.985 13.6122 17.3582 13.8277L26.0965 18.8727C26.4697 19.0882 26.7796 19.3981 26.9951 19.7713C27.2105 20.1445 27.324 20.5678 27.324 20.9988C27.324 21.4297 27.2105 21.853 26.9951 22.2262C26.7796 22.5994 26.4697 22.9093 26.0965 23.1248Z",
    fill: "#F7FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButtonOff);
export default __webpack_public_path__ + "static/media/nextButtonOFF.5a9890fb5c3bca0c5d25b0130e1dbe68.svg";
export { ForwardRef as ReactComponent };